<template>
  <div class="topfeature">
    <div class="renew3_wrapper">
      <ul class="flex topfeature_list">
        <li class="topfeature_item">
          <svg class="topfeature_icon" viewBox="0 0 48 48" aria-hidden="true">
            <circle cx="18" cy="16" r="7" />
            <path d="M5 41c0-7.2 5.8-13 13-13s13 5.8 13 13z" />
            <circle cx="34" cy="18" r="5.5" opacity="0.55" />
            <path
              d="M43 41c0-5.5-4-10-9-10.6"
              opacity="0.55"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
          <div class="topfeature_body">
            <p class="topfeature_label">利用実績</p>
            <p class="topfeature_main">
              <span class="topfeature_num">1,500</span>万人
            </p>
            <p class="topfeature_sub">突破！</p>
          </div>
        </li>
        <!-- 帯の中でここだけ緑ベタにして「5分で終わる」を主役にする -->
        <li class="topfeature_item topfeature_item_hero">
          <svg class="topfeature_ring" viewBox="0 0 52 52" aria-hidden="true">
            <circle class="topfeature_ring_track" cx="26" cy="26" r="22" />
            <circle class="topfeature_ring_fill" cx="26" cy="26" r="22" />
            <text
              class="topfeature_ring_text"
              x="26"
              y="31"
              text-anchor="middle"
            >
              5分
            </text>
          </svg>
          <div class="topfeature_body">
            <p class="topfeature_label">履歴書がたった</p>
            <p class="topfeature_main">5分で完成</p>
            <p class="topfeature_sub">スマホでもPCでもOK</p>
          </div>
        </li>
        <li class="topfeature_item topfeature_item_share">
          <!-- 確認画面のポップアップと同じイラスト付きバナー（ReferralCampaignBanner）を
               同じクラスで直書きする。この帯は public/top-content.html へ静的抽出される
               （初回表示・SEO はそのHTMLが出る）ので、文言は式や referralCampaign.json の
               参照ではなく直書きにする（式にすると静的HTML側に {{ }} がそのまま残る）。
               未ログインでも出し、押したらログインページ経由でマイページへ戻す
               （静的HTMLでもリンクとして動くよう出し分けの v-if は付けない） -->
          <div class="referral-banner topfeature_referral">
            <a
              href="/mypage/yagiprime"
              class="referral-banner__link"
              data-placement="top_feature_strip"
              aria-label="ヤギプライム紹介割引キャンペーンをマイページで確認"
              @click="onCampaignLinkClick"
            >
              <span class="referral-banner__inner">
                <!-- 帯の高さ（ほかのセルと同じ）を保つため、バッジは見出しの上に
                     積まずセルの上端に1行で置き、その下にフクロウ・見出し・丸を並べる -->
                <span class="topfeature_referral_top">
                  <span class="referral-banner__badge">
                    <span class="referral-banner__badge-line"
                      >友だちに紹介すると、お互い</span
                    >
                    <span class="referral-banner__badge-line"
                      >ヤギプライム30日無料！</span
                    >
                  </span>
                </span>
                <img
                  class="referral-banner__owl"
                  src="/static/img/yagiprime-referral/owl-letter.png"
                  alt=""
                  width="400"
                  height="299"
                />
                <span class="referral-banner__body">
                  <span class="referral-banner__title">
                    <span class="referral-banner__title-line"
                      >ヤギプライム</span
                    >
                    <span class="referral-banner__title-line"
                      >紹介割引キャンペーン</span
                    >
                  </span>
                </span>
                <span class="referral-banner__circle" aria-hidden="true">
                  <span class="referral-banner__circle-lead">今だけ</span>
                  <span class="referral-banner__circle-main">30日無料!</span>
                </span>
                <svg
                  class="referral-banner__chevron"
                  viewBox="0 0 12 20"
                  aria-hidden="true"
                >
                  <path d="M2 2l8 8-8 8" />
                </svg>
              </span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * トップのメインバナー下にある3カラム帯（実績・スピード・シェア）。
 *
 * Top.vue（1,700行超）の分解で切り出した。3つ目のカラムが紹介キャンペーンの入口。
 *
 * 見た目は @/assets/scss/top/feature-strip.scss に全部あるので、この SFC は
 * import するだけ。親から渡すものは無い。
 *
 * 3つ目のカラムは紹介キャンペーンの入口。確認画面のポップアップと同じ
 * イラスト付きバナーを置き、マイページのキャンペーン枠（紹介URL・紹介の状況）へ送る。
 * 共有そのものはマイページ側の枠でやってもらう。未ログインは /mypage が
 * requiresAuth で素の /login へ飛ばされ、ログイン後に /mypage トップへ落ちるので、
 * frompage 付きでログインページへ送ってキャンペーン枠へ戻す。
 *
 * **文言はテンプレートに直書きする。** この帯は `scripts/extract-top-static.js` が
 * public/top-content.html へ静的抽出し、初回表示と SEO はそのHTMLが使われるため、
 * computed や JSON から差し込むと静的HTML側に `{{ }}` が残ってしまう。
 * キャンペーンの文言カタログ（referralCampaign.json）はここでは使わない。
 */
import { useRouter } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'

const { isAuthenticated } = useAuth()
const router = useRouter()

// トップにはログインダイアログが無いのでログインページへ送り、
// ログイン後にキャンペーン枠へ戻す（NewLogin.vue の frompage 分岐）
function onCampaignLinkClick(event: MouseEvent): void {
  if (isAuthenticated.value) return
  event.preventDefault()
  router.push({ path: '/login', query: { frompage: 'yagiprime_referral' } })
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/yagiprime/referral-campaign-banner';
@import '@/assets/scss/top/feature-strip';
</style>
